<template>
  <div class="page" data-name="indi-info">
    <f7-navbar>			
			<div class="title">개인정보취급 방침</div>
			<f7-nav-right>
				<f7-link icon-ios="f7:close" icon-aurora="f7:close" icon-md="material:close" class="back"></f7-link>
			</f7-nav-right>
		</f7-navbar>

    <div class="page-content">
      
      <div class="block">
        <p>(주)오투라인 ('https://www.bj-sup.kr' 이하 '벤자민의 숲')은(는) 개인정보보호법에 따라 이용자의 개인정보 보호 및 권익을 보호하고 개인정보와 관련한 이용자의 고충을 원활하게 처리할 수 있도록 다음과 같은 처리방침을 두고 있습니다.</p>
        <p>(주)오투라인 ('벤자민의 숲')은(는) 회사는 개인정보처리방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다.</p>
        <p>○ 본 방침은부터 2020년 10월 01일부터 시행됩니다.</p>        
      </div>

      <div class="block-title">
        1. 개인정보의 처리 목적
      </div>
      <div class="block"> 
        <p>
          (주)오투라인 ('https://www.bj-sup.kr' 이하 '벤자민의 숲')은(는) 개인정보를 다음의 목적을 위해 처리합니다. 처리한 개인정보는 다음의 목적이외의 용도로는 사용되지 않으며 이용 목적이 변경될 시에는 사전동의를 구할 예정입니다
        </p>
        <p><strong>가. 홈페이지 회원가입 및 관리</strong></p>
        <p>
          회원제 서비스 제공, 이용자 식별, 회원탈퇴 의사의 확인.<br>
          회원 가입의사 확인, 회원자격 유지·관리 등을 목적으로 개인정보를 처리합니다.
        </p>
        <p><strong>나. 재화 또는 서비스 제공</strong></p>  
        <p>서비스 제공, 콘텐츠 제공 등을 목적으로 개인정보를 처리합니다.</p>     
      </div>
      <div class="block-title">
        2. 수집하는 개인정보 항목 및 수집방법
      </div>
      <div class="block"> 
        <p>
          <strong>☞ 당사는 원칙적으로 개인정보를 최소한으로 수입하고 있으며, 선택항목을 입력하지 않은 경우에도 서비스를 이용에 제한이 없습니다.</strong><br>
          이용자는 회원가입을 해야 학습과 관련된 기능과 화면들을 이용할 수 있습니다. 원활한 서비스 이용과 이용자 개인별 시험출제 및 학습 결과등의 기능을 이용하기 위해 회원가입시 (주)오투라인 ('벤자민의 숲')은(는) 서비스 이용을 위해 필요한 최소한의 개인정보를 수집합니다.
        </p>
        
        <p>
          <strong>회원가입시 이용자로 부터 수집하는 개인정보는 다음과 같습니다.</strong><br>
          - 이름, 생년월일, 로그인ID, 비밀번호, 비밀번호 질문 답변을 필수 항목으로 수집합니다. 만약, 이용자가 입력하는 생년월일이 만14세 미만 아동일 경우, 법정대리인 정보를 추가로 수집합니다.<br>
          - 학생 휴대전화번호, 이메일, 집주소를 선택항목으로 수집합니다.
        </p>

        <p>
          <strong>서비스 이용과정에서 이용자로부터 수집하는 개인정보는 다음과 같습니다. </strong><br>
          - PC 서비스 이용기록, PC 방문일시, PC 쿠키, PC 접속IP 정보, PC MAC address가 필수 항목으로 자동 수집됩니다.
        </p>
      </div>
      <div class="block-title">
        3. 수집한 개인정보의 보유 및 이용기간
      </div>
      <div class="block">        
        <strong>☞ 당사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다. </strong><br>
        <div class="list no-hairlines">
          <ul>
            <li>
              ① 서비스 이용 종료시 보존 개인정보<br>
              - 보존항목: 이름, 생년월일, 로그인ID, 비밀번호, 비밀번호 질문 답변, 학생 휴대전화번호, 이메일, 집주소<br>
              - 보존근거: 서비스 복구<br>
              - 보존기간: 서비스 이용 종료후 2개월<br>
            </li>
            <li>
              ② 웹사이트 방문 기록<br>
              - 보존항목: 접속 IP 정보, Mac address, PC 방문 일시, 스마트기기 접속 IP 정보, 스마트기기 Mac address, 스마트기기 방문 일시 <br>
              - 보존근거: 통신 비밀 보호법 <br>
              - 보존기간: 3개월 <br>
            </li>
          </ul>
        </div>       
      </div>
      <div class="block-title">
        4. 쿠키관련(개인정보 자동 수집장치의 설치운영 및 그 거부에 관한 사항)
      </div>
      <div class="block">
        <p>
          <strong>☞(주)오투라인 ('벤자민의 숲')은(는) 홈페이지 운영에 있어 필요 시 정보를 찾아내고 저장하는 ‘쿠키(Cookie)’를 운용합니다. 쿠키는 회사의 웹사이트를 운영하는데 이용되는 서버가 고객의 브라우저에 보내는 아주 작은 텍스트 파일로서 고객의 컴퓨터 하드디스크에 저장됩니다. 고객께서는 웹브라우저의 보안 정책을 통해 쿠키에 의한 정보수집의 허용거부 여부를 결정하실 수 있습니다.</strong>
        </p>
        <div class="list no-hairlines">
          <ul>
            <li>
              ① 쿠키에 의해 수집되는 정보 및 이용 목적<br>
              - 보존항목: 이름, 생년월일, 로그인ID, 비밀번호, 비밀번호 질문 답변, 학생 휴대전화번호, 이메일, 집주소<br>
              - 보존근거: 서비스 복구 <br>
              - 보존기간: 서비스 이용 종료후 2개월 <br>
              가. 수집 정보 : ID, 접속 IP, 접속로그, 이용 콘텐츠 등 서비스 이용정보 <br>
              나. 이용목적 <br> 
              • 고객의 관심분야에 따라 차별화된 정보를 제공 <br>    
              • 회원과 비회원의 접속 빈도나 방문시간 등을 분석하고 이용자의 취향과 관심분야를 파악하여 타켓(Target) 마케팅 및 서비스 개편 등의 척도로 활용합니다. <br>
            </li>
            <li>
              ② <mark>고객은 쿠키 설치에 대한 선택권을 가지고 있습니다.</mark> 따라서 웹브라우저에서 옵션을 설정함으로써 쿠키에 의한 정보수집 수준의 선택을 조정하실 수 있습니다.<br>
              가. 웹브라우저의 [도구]메뉴에서 [인터넷옵션]->[보안]->[사용자 정의수준]을 선택하여 쿠키에 의한 정보 수집 수준을 정할 수 있습니다. <br>
              나. 위에 제시된 메뉴를 통해 쿠키가 저장될 때마다 확인을 하거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다. 단, 고객께서 쿠키 설치를 거부하였을경우 서비스 제공에 어려움이 있을 수 있습니다.<br>
            </li>
            <li></li>            
          </ul>
        </div>
      </div>
      <div class="block-title">
        5. 개인정보처리 위탁
      </div>
      <div class="block">
        <p>
          ① (주)오투라인 (‘벤자민의 숲')은(는) 서비스 향상을 위해서 아래와 같이 개인정보를 위탁하고 있으며, 관계 법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다.<br>
          수탁업체 : (주)디콘밸리 <br>
          위탁업무 내용 : 학습자 인적성 검사 및 검사결과 조회 <br>
          개인정보 수집 시점 : 인적성 검사 실행시 <br>
          개인정보 보유 및 이용기간 : 회원탈퇴시 혹은 위탁계약 종료시까지 <br>
        </p>
      </div>
      <div class="block-title">
        6. 정보주체의 권리,의무 및 그 행사방법 이용자는 개인정보주체로서 다음과 같은 권리를 행사할 수 있습니다.
      </div>
      <div class="block">
        <div class="list no-hairlines">
          <ul>
            <li>
              ① 정보주체는 (주)오투라인(‘https://www.bj-sup.kr’ 이하 ‘벤자민의 숲') 에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.<br>
              1. 개인정보 열람요구<br>
              2. 오류 등이 있을 경우 정정 요구<br>
              3. 삭제요구<br>
              4. 처리정지 요구<br>
            </li>
            <li>
              ② 제1항에 따른 권리 행사는 (주)오투라인(‘https://www.bj-sup.kr’ 이하 ‘벤자민의 숲’) 에 대해 개인정보 보호법 시행규칙 별지 제8호 서식에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며, (주)오투라인(‘https://www.bj-sup.kr’이하 ‘벤자민의 숲') 은(는) 이에 대해 지체 없이 조치하겠습니다.
            </li>
            <li>
              ③ 정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 (주)오투라인(‘https://www.bj-sup.kr’이하 ‘벤자민의 숲’) 은(는) 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.
            </li>
            <li>
              ④ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.
            </li>
          </ul>
        </div>
      </div>
      <div class="block-title">
        7. 개인정보의 파기
      </div>
      <div class="block">
        <p>
          (주)오투라인 ('벤자민의 숲')은(는) 원칙적으로 개인정보 처리목적이 달성된 경우에는 지체없이 해당 개인정보를 파기합니다. 파기의 절차, 기한 및 방법은 다음과 같습니다.
        </p>
        <div class="list no-hairlines">
          <ul>
            <li>
              <strong>-파기절차</strong><br>
              이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져(종이의 경우 별도의 서류) 내부 방침 및 기타 관련 법령에 따라 일정기간 저장된 후 혹은 즉시 파기됩니다. 이 때, DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 다른 목적으로 이용되지 않습니다.
            </li>
            <li>
              <strong>-파기기한</strong><br>
              이용자의 개인정보는 개인정보의 보유기간이 경과된 경우에는 보유기간의 종료일로부터 5일 이내에, 개인정보의 처리 목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을 때에는 개인정보의 처리가 불필요한 것으로 인정되는 날로부터 5일 이내에 그 개인정보를 파기합니다.
            </li>
            <li>
              <strong>-파기방법</strong><br>
              전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다.
            </li>            
          </ul>
        </div>
      </div>
      <div class="block-title">
        8. 개인정보의 안전성 확보 조치
      </div>
      <div class="block">
        <p>(주)오투라인('벤자민의 숲')은(는) 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한 기술적/관리적 및 물리적 조치를 하고 있습니다.</p><br>
        <div class="list no-hairlines">
          <ul>
            <li>
              <strong>1. 개인정보 취급 직원의 최소화 및 교육</strong><br>
              개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화 하여 개인정보를 관리하는 대책을 시행하고 있습니다.
            </li>
            <li>
              <strong>2. 정기적인 자체 감사 실시</strong><br>
              개인정보 취급 관련 안정성 확보를 위해 정기적(분기 1회)으로 자체 감사를 실시하고 있습니다.
            </li>
            <li>
              <strong>3. 내부관리계획의 수립 및 시행</strong><br>
              개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고 있습니다.
            </li>
            <li>
              <strong>4. 개인정보의 암호화</strong><br>
              이용자의 개인정보는 비밀번호는 암호화 되어 저장 및 관리되고 있어, 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송 데이터를 암호화 하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 사용하고 있습니다.
            </li>
            <li>
              <strong>5. 해킹 등에 대비한 기술적 대책</strong>
              (주)오투라인 ('벤자민의 숲')은 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치하고 주기적인 갱신·점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다.
            </li>
            <li>
              <strong>6. 개인정보에 대한 접근 제한</strong>
              개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여,변경,말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.
            </li>
            <li>
              <strong>7. 접속기록의 보관 및 위변조 방지</strong>
              개인정보처리시스템에 접속한 기록을 최소 6개월 이상 보관, 관리하고 있으며, 접속 기록이 위변조 및 도난, 분실되지 않도록 보안기능 사용하고 있습니다.
            </li>
          </ul>
        </div>
      </div>
      <div class="block-title">
        9. 개인정보 보호책임자
      </div>
      <div class="block">
        <div class="list no-hairlines">
          <ul>
            <li>
              <p>
                ① (주)오투라인(‘https://www.bj-sup.kr’ 이하 ‘벤자민의 숲’) 은(는) 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
              </p>
              <p>
                <strong>▶ 개인정보 보호책임자</strong><br>
                성명 :박권수<br>
                직책 :개인정보 관리 책임자<br>
                직급 :이사<br>
                연락처 :070-7860-6585, privacy@otwoline.co.kr<br>
              </p>
              <p>
                <strong>▶ 개인정보 보호 담당부서</strong><br>
                부서명 :개인정보보호실<br>
                담당자 :김태인<br>
                연락처 :070-7860-6585, privacy@otwoline.co.kr<br>
              </p>
            </li>
            <li>
              ② 정보주체께서는 (주)오투라인(‘https://www.bj-sup.kr’이하 ‘벤자민의 숲’) 의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. (주)오투라인(‘https://www.bj-sup.kr’ 이하 ‘벤자민의 숲’) 은(는) 정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.
            </li>
          </ul>
        </div>
      </div>
      <div class="block-title">
        10. 개인정보 처리방침 변경
      </div>
      <div class="block">
        ① 이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.
      </div>
    </div>
  </div>
</template>

<script>
import MODULE from '../../js/common/module';
import Vue from 'vue';
import PAGES from '../../js/pages';
import CONST from '../../js/common/constant';
import API from '../../js/common/api';
import AUTH from '../../js/common/auth';

export default {
  data() {
    return {
   
    }
  },
  mounted() {
   
  },
  methods: {
    
  }
}

</script>